import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import DeltaArrowDown from './icon-delta-arrow-down.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <DeltaArrowDown {...validProps} />;
}
SvgComponent.iconName = 'deltaArrowDown';

export const DeltaArrowDownIcon = svgIconWrapper(SvgComponent);
